import {SOPostDatafeed} from '../../core/datafeed/so-post-datafeed';
import {DatafeedCore} from './datafeed.core';
import {SOGetDatafeed} from '../../core/datafeed/so-get-datafeed';
import {FormField, SelectionOption} from 'lionheartland';
import {postDatafeedFormFieldOptions} from './post-datafeed-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {UserCore} from '../user/user.core';
import {SOGetUser} from '../../core/user/so-get-user';

export class RAPostDatafeed extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postDatafeedFormFieldOptions);

  RequestClass = SOPostDatafeed

  constructor(
    public entityCore: DatafeedCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'user',
        SOGetUser,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}